// @ts-expect-error mzdata is not typed
import { parseMZ } from 'mzdata';
import { fromJSON } from "../chromatogram.js";
/**
 * Creates a new Chromatogram from supported XML formats.
 * @param xml - String containing the XML chromatogram.
 */
export async function fromXML(xml) {
    return fromJSON(await parseMZ(xml));
}
//# sourceMappingURL=xml.js.map